import {
  FormErrorMessage,
  Image,
  Input,
  useDisclosure,
} from "@chakra-ui/react";
import CardFormAlt from "../CardFormAlt";
import ResponsiveFormControl from "../ResponsiveFormControl";
import { ModalContent } from "../FullWidthModal";
import { InheritModalContentProps } from "../FullWidthModal/interface";
import { IMCFormQuotationDetail } from "./interface";
import FieldSearchModal from "../FieldSearchModal";
import ModalSearchSignature from "../ModalSearchSignature";
import ModalSearchSignatureBackground from "../ModalSearchSignatureBackground";

const MCFormQuotationDetail: React.FC<
  InheritModalContentProps<IMCFormQuotationDetail>
> = ({ ...props }) => {
  const {
    onOpen: onOpenSignature,
    onClose: onCloseSignature,
    isOpen: isOpenSignature,
  } = useDisclosure();

  const {
    onOpen: onOpenSignatureBackground,
    onClose: onCloseSignatureBackground,
    isOpen: isOpenSignatureBackground,
  } = useDisclosure();

  return (
    <ModalContent {...props}>
      {({ register, errors, watch, setValue }) => {
        const watchSignature = watch("signature");
        const watchSignatureBackground = watch("signatureBackground");

        return (
          <form autoComplete="off">
            <CardFormAlt
              boxShadow="rgba(0, 0, 0, 0.04) 0px 1px 4px"
              borderRadius="8px"
              padding="26px 24px"
              title="Quotation Information"
              mb={10}
            >
              <ResponsiveFormControl
                label="Booking Code"
                isInvalid={errors.hasOwnProperty("bookingCode")}
              >
                <Input {...register("bookingCode", { required: true })} />
                <FormErrorMessage>Booking Code is requied!</FormErrorMessage>
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="Itinerary Date"
                isInvalid={errors.hasOwnProperty("itineraryDate")}
              >
                <Input
                  w="50%"
                  type="date"
                  {...register("itineraryDate", { required: true })}
                />
                <FormErrorMessage>Itinerary Date is required!</FormErrorMessage>
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="Itinerary"
                isInvalid={errors.hasOwnProperty("itinerary")}
              >
                <Input {...register("itinerary", { required: true })} />
                <FormErrorMessage>Itinerary is requied!</FormErrorMessage>
              </ResponsiveFormControl>
              <ResponsiveFormControl
                label="To"
                isInvalid={errors.hasOwnProperty("to")}
              >
                <Input {...register("to", { required: true })} />
                <FormErrorMessage>To is requied!</FormErrorMessage>
              </ResponsiveFormControl>
            </CardFormAlt>
            <CardFormAlt title="Signature Information">
              <ResponsiveFormControl label="Signature Name">
                <FieldSearchModal
                  value={watchSignature?.name || ""}
                  onSearchClick={() => onOpenSignature()}
                  onClearClick={() => setValue("signature", null)}
                  placeholder="Use Default"
                  showClearButton={watchSignature ? true : false}
                />
                <Input type="hidden" {...register("signature")} />
              </ResponsiveFormControl>
              {watchSignature && (
                <ResponsiveFormControl label="Image">
                  <Image src={watchSignature.imageUrl} h="80px" w="auto" />
                </ResponsiveFormControl>
              )}

              <ResponsiveFormControl label="Signature Background">
                <FieldSearchModal
                  value={watchSignatureBackground?.name || ""}
                  onSearchClick={() => onOpenSignatureBackground()}
                  onClearClick={() => setValue("signatureBackground", null)}
                  placeholder="Use Default"
                  showClearButton={watchSignatureBackground ? true : false}
                />
                <Input type="hidden" {...register("signatureBackground")} />
              </ResponsiveFormControl>
              {watchSignatureBackground && (
                <ResponsiveFormControl label="Image">
                  <Image
                    src={watchSignatureBackground.imageUrl}
                    h="80px"
                    w="auto"
                  />
                </ResponsiveFormControl>
              )}
            </CardFormAlt>
            <ModalSearchSignature
              isOpen={isOpenSignature}
              onClose={onCloseSignature}
              onSelect={(item) => {
                setValue("signature", item, {
                  shouldValidate: true,
                });
                onCloseSignature();
              }}
            />

            <ModalSearchSignatureBackground
              isOpen={isOpenSignatureBackground}
              onClose={onCloseSignatureBackground}
              onSelect={(item) => {
                setValue("signatureBackground", item, {
                  shouldValidate: true,
                });
                onCloseSignatureBackground();
              }}
            />
          </form>
        );
      }}
    </ModalContent>
  );
};

export default MCFormQuotationDetail;
